import React, { useState, useEffect } from 'react';
import {
  KTSVG,
  LoadingGrid,
  formatDateMonth,
  formatPriceMejorado,
} from '../../../../../_mexablock/helpers';
import { TopUpBalanceModal } from '../../../../../_mexablock/partials/modals/balance/TopUpBalanceModal';
import { NewActivationModal } from '../_modals/NewActivation';
import { MultipleModal } from '../_modals/MultipleModal';
import { useGetAll } from '../hooks/ActivacionHook';
import { TableList } from '../../../../../_mexablock/helpers/components/TableList';

const View: React.FC = () => {
  const [loadingView, setloadingView] = useState<boolean>(true);
  const [idRow, setIdRow] = useState(0);
  const [visivilityModal, setVisivilityModal] = useState<boolean>(false);
  const [multipleModal, setMultipleModal] = useState<boolean>(false);
  const [visivilityRechargeModal, setVisivilityRechargeModal] =
    useState<boolean>(false);
  const [titleModal, setTitleModal] = useState<string>('');
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);
  const [initFilterValues] = useState({
    nombre: '',
  });
  const { data, loadingRequest } = useGetAll(reloadGrid, initFilterValues);

  useEffect(() => {
    if (loadingRequest > 0) {
      setloadingView(false);
    }
  }, [loadingRequest]);

  const normalActivation = () => {
    setTitleModal('Activación');
    setVisivilityModal(!visivilityModal);
  };

  const columns: any = [
    {
      id: 'createdAt',
      name: <div className="fw-bolder text-muted me-5">Fecha</div>,
      selector: (row: any) => row.createdAt,
      cell: (row: any) => formatDateMonth(row.createdAt),
      sortable: true,
    },
    {
      id: 'source',
      name: <div className="fw-bolder text-muted me-5">Canal</div>,
      selector: (row: any) => row.source,
      sortable: true,
    },
    {
      id: 'identifier_value',
      name: <div className="fw-bolder text-muted me-5">ICCID</div>,
      selector: (row: any) => row.identifier_value,
      sortable: true,
    },
    {
      id: 'customer',
      name: <div className="fw-bolder text-muted me-5">Cliente</div>,
      selector: (row: any) =>
        `${row.customer?.first_name} ${row.customer?.father_last_name}`,
      sortable: true,
    },
    {
      id: 'amount',
      name: <div className="fw-bolder text-muted me-5">Monto</div>,
      selector: (row: any) => formatPriceMejorado(row.amount, 'es-MX', 'MXN'),

      sortable: true,
    },

    {
      id: 'userCreate',
      name: <div className="fw-bolder text-muted me-5">Usuario</div>,
      selector: (row: any) =>
        `${row.userCreate?.first_name} ${row.userCreate?.father_last_name}`,
      // Usuario App
      sortable: true,
    },
  ];

  return (
    <>
      <div className="row gy-5 g-xl-8">
        <div className="col-xl-12">
          <div className={`card card-xxl-stretch mb-5 mb-xl-12`}>
            <div className="card-header border-0 pt-5">
              <div className="card-title align-items-start flex-column"></div>
              <div
                className="card-toolbar"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                data-bs-trigger="hover"
                title="Nuevo registro"
              >
                <a
                  href="#/"
                  data-kt-menu="true"
                  className="btn btn-sm btn-light-primary"
                  data-kt-menu-trigger="click"
                  data-kt-menu-placement="bottom-end"
                >
                  <KTSVG
                    path="/media/icons/duotune/arrows/arr075.svg"
                    className="svg-icon-5 svg-icon-gray-500 me-1"
                  />
                  Nueva activación
                </a>
                <div
                  className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4"
                  data-kt-menu="true"
                >
                  <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      data-kt-users-table-filter="delete_row"
                      href="#/"
                      onClick={normalActivation}
                    >
                      Única
                    </a>
                  </div>
                  {/* <div className="menu-item px-3">
                    <a
                      className="menu-link px-3"
                      data-kt-users-table-filter="delete_row"
                      href="#/"
                      onClick={multipleActivation}
                    >
                      Multiple
                    </a>
                  </div> */}
                </div>
              </div>
            </div>

            {loadingView ? (
              <LoadingGrid text="Cargando..."></LoadingGrid>
            ) : (
              <TableList data={data} columns={columns}></TableList>
            )}
          </div>
        </div>
      </div>
      <NewActivationModal
        show={visivilityModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            // setLoadingGrid(true);
            setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setVisivilityModal(!visivilityModal);
        }}
      ></NewActivationModal>

      <TopUpBalanceModal
        show={visivilityRechargeModal}
        handleClose={(updateData: boolean) => {
          setVisivilityRechargeModal(!visivilityRechargeModal);
        }}
      />
      <MultipleModal
        id_row={idRow}
        title={titleModal}
        show={multipleModal}
        handleClose={(updateGrid: boolean) => {
          if (updateGrid) {
            // setLoadingGrid(true);
            // setReloadGrid(Math.random() * 40);
          }
          setIdRow(0);
          setMultipleModal(!multipleModal);
        }}
      ></MultipleModal>
    </>
  );
};

export { View };
